export default __webpack_public_path__ + "static/media/walletconnect.dcbdafe7.ico";